import {
    useMemo,
    useState
} from 'react';

import { ContractorRoutes } from './ContractorRoutes';
import { LinearProgress } from '@mui/material';
import { OrganizationType } from '../../API';
import { PropertyManagerRoutes } from './PropertyManagerRoutes';
import { useUser } from '../../components/user/UserContext';

const RoutesByAccountType = () => {
    const { accountType, isLoading } = useUser();
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);

    const Component = useMemo(() => {
        if (isLoading && !initialLoadComplete) {
            return <LinearProgress />;
        }
        setInitialLoadComplete(true);
        switch (accountType) {
            case OrganizationType.PROPERTY_MANAGEMENT:
                return <PropertyManagerRoutes />;
            case OrganizationType.CONSULTANT:
            case OrganizationType.SOLE_SOURCE:
            default:
                return <ContractorRoutes />;
        }
    }, [accountType]);

    return Component;
};

export default RoutesByAccountType;